import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TSyaryoKeihiGetListReq, TSyaryoKeihiGetListRes } from "./TSyaryoKeihi"

/**
 * 車輌経費に対するAPIリクエスト用サービス
 *
 * @export
 * @class SyaryoKeihiService
 * @extends {ConnectApi}
 */
export default class SyaryoKeihiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyaryoKeihiGetListReq} params
   * @memberof SyaryoKeihiService
   */
  getList = async (params: TSyaryoKeihiGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyaryoKeihiGetListRes[]>> =
        await this.getInner(`/budget/syaryokeihi`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
